@if (dialog.request(); as request) {
  <div class="dirty-changes-dialog__backdrop" (click)="dialog.keepEditing()">
    <section
      class="dirty-changes-dialog"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="dirty-changes-dialog-title"
      aria-describedby="dirty-changes-dialog-message"
      (click)="$event.stopPropagation()">
      <div class="dirty-changes-dialog__icon" aria-hidden="true">
        <i class="fas fa-pen-to-square"></i>
      </div>

      <div class="dirty-changes-dialog__copy">
        <span class="dirty-changes-dialog__eyebrow">Unsaved changes</span>
        <h2 id="dirty-changes-dialog-title">{{ request.title }}</h2>
        <p id="dirty-changes-dialog-message">{{ request.message }}</p>
      </div>

      <div class="dirty-changes-dialog__actions">
        <button type="button" class="dirty-changes-dialog__cancel" autofocus (click)="dialog.keepEditing()">
          {{ request.cancelText }}
        </button>
        <button type="button" class="dirty-changes-dialog__discard" (click)="dialog.discard()">
          {{ request.discardText }}
        </button>
      </div>
    </section>
  </div>
}
